export default __webpack_public_path__ + "static/media/prologue-cat.bfc11ea0.png";